<template>
  <div>
  <div v-if="job" class="h-screen bg-white w-full"> 

      <div v-if="showCompletion" class="fixed top-0 left-0 z-50 items-center flex h-screen w-full p-4 bg-gray-900 bg-opacity-50">
        <div class="w-full h-56 rounded-lg bg-white p-6 relative">
          <div class="absolute top-0 right-0 m-4" @click="showCompletion = false">
            <i class="fa-solid fa-xmark"></i>
          </div>

          <div class="w-full mb-4">What would you like to do</div>
          
          <div @click="updateCard('COMPLETED')" class="bg-primary text-white rounded m-2 p-4 header-heavy">
          Complete Job
        </div>

        <div @click="updateCard('CANCELLED')" class="bg-gray-900 text-white rounded m-2 p-4 header-heavy">
          Cancel Job
        </div>

        </div>
      </div>

    <div 
    :class="cardStyle()"
    class="w-full py-10 relative">
     


      <!-- <div @click="switchContractor()" class="h-12 w-12 bg-gray-900 rounded flex items-center justify-center absolute top-0 right-0 m-4 w-6 h-6 text-white">
        <i class="fa-solid fa-shuffle"></i>
      </div> -->

      <!-- <img
        @click="loadContractor()"
        v-if="job.tester && job.tester.avatar"
        class="rounded-full h-20 w-20 shadow mx-auto object-cover"
        :src="job.tester.avatar"
        alt="Profile Image"
      />
      <img
        v-else
        class="rounded-full h-20 w-20 shadow mx-auto object-cover"
        src="data:image/jpeg;base64,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"
        alt="Profile Image"
      /> -->

      <h2
        v-if="job.tester"
        @click="loadContractor()"
        class="mt-6 text-white header-heavy tracking-tight text-xl"
      >
      <span class="text-xs header-medium">Tester:</span><br />
        {{ job.tester }}
      </h2>

      
      <h2
        v-else
        @click="loadContractor()"
        class="mt-6 text-white header-heavy tracking-tight text-xl"
      >
        No Assigned Tester
      </h2>

      <div class="w-56 mx-auto my-4 flex space-x-4 justify-center text-white rounded bg-white p-2 bg-opacity-10">
        <div class="flex-shrink font-bold">
          Status:
        </div>
        <div class="flex-shrink">
          {{ job.status }}
        </div>
      </div>
      <div @click="showAcceptModal = true" class="w-full mb-4 flex items-center justify-center" v-if="!job.accepted && !job.rejected">
  <div class="bg-blue-600 text-white rounded h-20 w-56 hover:bg-blue-800 cursor-pointer flex items-center justify-center">
    <span v-if="currentUser.role == 'admin'">Accept Job On Behalf of contractor</span> 
    <span v-else>ACCEPT JOB</span> 
  </div>
</div>

<!-- Accept Job Modal -->
<div v-if="showAcceptModal" class="fixed top-0 left-0 z-50 items-center flex h-screen w-full p-4 bg-gray-900 bg-opacity-50">
  <div class="w-full h-56 rounded-lg bg-white p-6 relative">
    <div class="absolute top-0 right-0 m-4" @click="showAcceptModal = false">
      <i class="fa-solid fa-xmark"></i>
    </div>

    <div class="w-full mb-4 text-lg font-semibold">Would you like to accept this job?</div>

    <div @click="acceptJob()" class="bg-green-600 text-white rounded m-2 p-4 header-heavy cursor-pointer">
      Accept Job
    </div>

    <div @click="rejectJob()" class="bg-red-600 text-white rounded m-2 p-4 header-heavy cursor-pointer">
      Reject Job
    </div>
  </div>
</div>


      <div class="w-full text-center mb-4"  v-if="job.accepted">
        <span class="bg-blue-100 mb-4 py-2 px-4 text-blue-600 text-sm rounded">
        This job has been accepted
        </span>
      </div>

      <div class="w-full text-center mb-4"  v-else-if="!job.accepted && job.rejected">
        <span class="bg-red-100 mb-4 py-2 px-4 text-red-600 text-sm rounded">
        This job has been rejected
        </span>
      </div>

      <div class="w-full my-6" v-if="currentUser.role == 'admin'">
        <select @change="updateSelect()" v-model="job.status" class="h-12 outline-none w-40 bg-white bg-opacity-25 text-white rounded px-4">
          <option>ON-CALL</option>
          <option>FIRM</option>
          <option>CANCELLED</option>
          <option>COMPLETED</option>
        </select>
      </div>

      <h2 class="font-bold text-white">Address</h2>
      <h2 class="text-white header text-base">
       
        {{ job.fullAddress }} 
        <a v-if="job.address && job.address.longitude && job.address.longitude" :href="'https://www.google.com/maps?q='+job.address.latitude+','+job.address.longitude" target="_blank" class="text-white underline text-xs cursor-pointer">View Map</a>
      </h2>

      <div class="px-10 my-6" v-if="currentUser.role =='contractor'">
      <div @click="showCompletion = true" class="bg-gray-900 text-white rounded m-2 p-4 header-heavy">
          Complete / Cancel Job
        </div>
      </div>
    </div>

    <div class="relative h-full -mt-4 bg-gray-200 rounded-t-xl p-2">
      <div
        class="mb-4 w-full bg-white border-2 border-dashed border-gray-500 rounded-lg text-left p-4"
      >
        <h2
          v-if="job.status == 'confirmed'"
          class="text-xl tracking-tight header-heavy text-gray-900"
        >
          <span class="w-4 h-4 bg-primary rounded-full inline-block"></span> JOB
          CONFIRMED
        </h2>
        <h2
          v-if="job.status == 'unconfirmed'"
          class="text-xl tracking-tight header-heavy text-gray-900"
        >
          <span class="w-4 h-4 bg-yellow-500 rounded-full inline-block"></span>
          JOB UNCONFIRMED
        </h2>
        <h2
          v-if="job.status == 'unscheduled'"
          class="uppercase text-xl tracking-tight header-heavy text-gray-900"
        >
          <span class="w-4 h-4 bg-red-600 rounded-full inline-block"></span> JOB
          Unscheduled
        </h2>


        <h2 class="header-bold text-gray-700 text-lg">Job Details</h2>
        
        <div>
          <span class="header-heavy text-sm">Client</span>
          
          <span class="ml-2">{{ job.client }}</span>
        </div>

        <div>
          <span class="header-heavy text-sm">Time</span>
          
          <span class="ml-2">{{ job.date }} at {{ job.time}}</span>
        </div>
        <div>
          <span class="header-heavy text-sm">Phone</span>
          <a :href="'tel:'+job.phone" class="text-primary ml-2">{{ job.phone }}</a>
        </div>

        <div v-if="!customFieldsEnabled">
          <span class="header-heavy text-sm">Meters</span>
          <span class="ml-2">{{ job.meters }} meters</span>
        </div>
        <div v-if="job.duration">
          <span class="header-heavy text-sm">Duration</span>
          <span class="ml-2">{{ job.duration }} min</span>
        </div>

        <div v-if="!customFieldsEnabled">
          <span class="header-heavy text-sm">Mix Code</span>
          <span class="ml-2">{{ job.mixCode }}</span>
        </div>
        <div v-for="f in testerFields" :key="f.key">
          <span class="header-heavy text-sm">{{ f.label }}</span>
          <span class="ml-2">{{ f.value }}</span>
        </div>
        <div>
          <span class="header-heavy text-sm">Requirements</span>
          <span class="ml-2">{{ job.requirements }}</span>
        </div>
        <div v-if="!customFieldsEnabled">
          <span class="header-heavy text-sm">Pour Location</span>
          <span class="ml-2">{{ job.pourLocation }}</span>
        </div>
        <div>
          <span class="header-heavy text-sm">Notes for tester</span>
          <span class="ml-2">{{ job.notesForTester }}</span>
        </div>

        <div class="pt-4 mt-4 border-t border-gray-300">
          <h2 class="header-bold text-gray-700 text-lg mb-3">Customer Details</h2>
        </div>
        <div class="mt-1">
          <span class="header-heavy text-sm">Customer</span>
          <span class="ml-2">{{ job.customer }}</span>
        </div>
        <div class="mt-1">
          <span class="header-heavy text-sm">Contact Name</span>
          <span class="ml-2">{{ job.contact }}</span>
        </div>

        <div class="mt-1">
          <span class="header-heavy text-sm">Email</span>
          <span class="ml-2">{{ job.email }}</span>
        </div>

        <div class="mt-1">
          <span class="header-heavy text-sm">Phone</span>
          <span class="ml-2">{{ job.phone }}</span>
        </div>

        <div class="w-full mt-2 ">
          <textarea @keyup="saveNotes" class="h-20 w-full border border-gray-200 rounded-lg p-2" v-model="job.testerNotes" placeholder="Tester notes"></textarea>
          <!-- <div class="h-10 flex items-center justify-center bg-primary text-white rounded" @click="saveNotes()">Save Notes</div> -->
        </div>
      </div>

      <iframe v-if="job.address && job.address.longitude && job.address.longitude"
  width="100%"
  height="450"
  style="border:0" class="rounded-lg shadow-lg"
  loading="lazy"
  allowfullscreen
  referrerpolicy="no-referrer-when-downgrade"
  :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyAgzzzBwnKAnilSbETwkny6ApTz18jlHr4&q='+job.address.latitude+','+job.address.longitude">
</iframe>

      <div v-if="job.status == 'confirmed'" class="w-full">
        <input type="file" id="actual-btn" class="hidden" />
        <label for="actual-btn">
          <div class="bg-primary text-white rounded m-2 p-4 header-heavy">
            <svg
              class="w-6 h-6 inline-block"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm4.707 3.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L8.414 9H10a3 3 0 013 3v1a1 1 0 102 0v-1a5 5 0 00-5-5H8.414l1.293-1.293z"
                clip-rule="evenodd"
              ></path>
            </svg>
            Attach Site Slip
          </div>
        </label>
      </div>

      <div v-if="job.status == 'unconfirmed'" class="w-full">
        <div class="w-full my-2 text-gray-400 text-xs">
          Confirmation sent about 2 hours ago
        </div>
        <div class="w-full my-2 text-gray-400 text-xs">
          Confirmation sent about 1 day ago
        </div>
        <div class="w-full my-2 text-gray-400 text-xs">
          Confirmation sent about 7 days ago
        </div>
        <input type="file" id="actual-btn" class="hidden" />
        <label for="actual-btn">
          <div class="bg-yellow-500 text-white rounded m-2 p-4 header-heavy">
            Send a Confirmation Request
          </div>
        </label>
      </div>

      <div v-if="job.status == 'unscheduled'" class="w-full mt-4">
        <div class="bg-red-600 text-white rounded m-2 p-4 header-heavy">
          MANUALLY ASSIGN A TESTER
        </div>
      </div>

     
    </div>
  </div>
</div>
</template>

<script>
import { bus } from "../../main";
import {setFire, getFire} from "../../firestore/utils"
import { loadDefinitions, resolveFieldValues } from "../../services/customFields"
export default {
  props: ["card"],
  data(){
    return{
      job: null,
      customFieldDefs: null,
      showAcceptModal: false,
      showCompletion: false
    }
  },
  watch:{
    cardStatus(){
      this.updateCard()
    }
  },
  created(){
    this.fetchJob()
    this.loadCustomFields()
  },
  computed:{
    currentUser(){
      return this.$store.state.currentUser
    },
    cardStatus(){
      return this.card.status
    },
    customFieldsEnabled(){
      return !!(this.customFieldDefs && this.customFieldDefs.enabled)
    },
    testerFields(){
      if (!this.customFieldsEnabled || !this.job) return []
      return resolveFieldValues(this.customFieldDefs, this.job, 'tester')
    }
  },
  methods: {
    async loadCustomFields() {
      this.customFieldDefs = await loadDefinitions();
    },
    async fetchJob() {
      this.job = await getFire({
    collection: 'jobs',
    doc: this.card.id
  });

    },
    async acceptJob() {
  await setFire({
    collection: 'jobs',
    doc: this.card.id,
    body: {
      accepted: true
    }
  });

  bus.$emit("showWorkCardFunc", { ...this.card, accepted: true, rejected: false });
  this.fetchJob()
 
  this.showAcceptModal = false;
  
  
},
async rejectJob() {
  await setFire({
    collection: 'jobs',
    doc: this.card.id,
    body: {
      accepted: false,
      rejected: true,
      rejectedDate: new Date()
    }
  });
  bus.$emit("showWorkCardFunc", { ...this.card, accepted: false, rejected: true });
  this.fetchJob()
  this.showAcceptModal = false;

  
},

   async saveNotes(){

      await setFire({
        collection: 'jobs',
        doc: this.card.id,
        body: {
          testerNotes: this.job.testerNotes
        }
      })

    },
    updateSelect(){
      this.updateCard(this.card.status)
    },
    // async acceptJob(){

    //   await setFire({
    //     collection: 'jobs',
    //     doc: this.card.id,
    //     body: {
    //       accepted: true
    //     }
    //   })

    //   bus.$emit("showWorkCardFunc", {...this.card, accepted: true});
    // },
    async updateCard(status){
      await setFire({
        collection: 'jobs',
        doc: this.job.id,
        body: {
          status: status
        }
      })

      this.showCompletion = false
      bus.$emit("showWorkCardFunc", {...this.card, status: status});
    },
    cardStyle(){
      if(this.card.status == 'ON-CALL') return 'bg-yellow-600'
      if(this.card.status == 'COMMITTED') return 'bg-blue-600'
      if(this.card.status == 'FIRM') return 'bg-green-500'
      if(this.card.status == 'CANCELLED') return 'bg-gray-600'
      if(this.card.status == 'COMPLETED') return 'bg-green-600'
    },
    loadContractor() {
      if(this.card.contractor) bus.$emit("loadOwnerCardFunc", this.card.contractor);
    },
    switchContractor(){
      bus.$emit("switchOwner", this.card);
    }
  }
};
</script>
